/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react';

export const InfoCircle1 = ({ className }) => {
    return (
        <svg
            className={`info-circle-1 ${className}`}
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g className="g" clipPath="url(#clip0_92_6962)">
                <path
                    className="path"
                    clipRule="evenodd"
                    d="M12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24Z"
                    fill="#121926"
                    fillRule="evenodd"
                />
                <path
                    className="path"
                    d="M13.3949 9.88184L9.95993 10.3123L9.83693 10.8823L10.5119 11.0068C10.9529 11.1118 11.0399 11.2708 10.9439 11.7103L9.83693 16.9123C9.54593 18.2578 9.99443 18.8908 11.0489 18.8908C11.8664 18.8908 12.8159 18.5128 13.2464 17.9938L13.3784 17.3698C13.0784 17.6338 12.6404 17.7388 12.3494 17.7388C11.9369 17.7388 11.7869 17.4493 11.8934 16.9393L13.3949 9.88184Z"
                    fill="#121926"
                />
                <path
                    className="path"
                    d="M12 8.25C12.8284 8.25 13.5 7.57843 13.5 6.75C13.5 5.92157 12.8284 5.25 12 5.25C11.1716 5.25 10.5 5.92157 10.5 6.75C10.5 7.57843 11.1716 8.25 12 8.25Z"
                    fill="#121926"
                />
            </g>
            <defs className="defs">
                <clipPath className="clip-path" id="clip0_92_6962">
                    <rect
                        className="rect"
                        fill="white"
                        height="24"
                        width="24"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
